var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglassSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#bda6cc",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#bda6cc",
    strokeWidth: 0.00032,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "hourglass"), /*#__PURE__*/React.createElement("path", {
    d: "M18.404 16.53v-1.057c3.511-1.669 6.086-7.082 6.086-13.52h-16.727c0 6.4 2.534 11.817 6.013 13.52v1.057c-3.479 1.703-6.013 7.12-6.013 13.52h16.727c0-6.437-2.575-11.851-6.086-13.52zM10.614 8.165c3.309 1.482 7.484 1.48 11.078-0.255-0.894 3.323-2.769 5.706-4.979 6.073 0.094 0.127 0.15 0.283 0.15 0.453 0 0.422-0.342 0.764-0.764 0.764s-0.764-0.342-0.764-0.764c0-0.172 0.058-0.331 0.154-0.458-2.141-0.374-3.96-2.636-4.874-5.812zM16.099 20.117c-0.422 0-0.764-0.342-0.764-0.764s0.342-0.764 0.764-0.764 0.764 0.342 0.764 0.764-0.342 0.764-0.764 0.764zM16.863 21.819c0 0.422-0.342 0.764-0.764 0.764s-0.764-0.342-0.764-0.764 0.342-0.764 0.764-0.764c0.422 0 0.764 0.342 0.764 0.764zM16.099 17.666c-0.422 0-0.764-0.342-0.764-0.764s0.342-0.764 0.764-0.764 0.764 0.342 0.764 0.764c0 0.422-0.342 0.764-0.764 0.764zM11.377 28.266c3.697-6.226 5.737-6.365 9.546 0h-9.546z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassSvgrepoCom);
export default __webpack_public_path__ + "static/media/hourglass-svgrepo-com.2ffb8842b09daaa859e7b2ac3ed204cc.svg";
export { ForwardRef as ReactComponent };